import { Tabs, Table } from "antd";
import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { showloader, transactionClicked } from "../store/gloabalState";
import { Link } from "react-router-dom";
import { DateConvert } from "../utils/dateConverter";
import { getFilteredTransactionAll } from "../services/httpCalls";
import { getcookieFunc } from "../utils/useCookies";

const UnassignedTransactions = () => {
    
    // local states
    const [totalCountUA, setTotalCountUA] = useState(0);
    const [unassignedTranasactions, setUnassignedTransactions] = useState([]);

    // global states

    // states

    // values

    // setter/updater
    const setShowLoader = useSetRecoilState(showloader);
    const setTransactionId = useSetRecoilState(transactionClicked)

    // constants/binders
    const accessToken = getcookieFunc();


    const colsUassigned = [
        {
          title: "TransactionId",
          dataIndex: "transactionId",
          key: "transactionId",
          align: "center",
          render: (val, record) => {
            if(record?.productType === "INWARD") {
              return(
                <Link
                to={"/transactiondetail/inward/" + val}
                style={{
                  color: "#000",
                }}
                onClick={() => {
                  setTransactionId(record?.transactionId);
                }}
              >
                {record?.transactionId}
              </Link>
              )
          } else {
              return(
                <Link
            to={"/transactiondetail/" + val}
            style={{
              color: "#000",
            }}
            onClick={() => {
              setTransactionId(record?.transactionId);
            }}
          >
            {record?.transactionId}
          </Link>
              )
          }
          }
        },
        {
          title: "Customer Name",
          dataIndex: "customerName",
          key: "customerName",
          align: "center",
          filterSearch: true,
          render: (val) => (val ? val : "-"),
        },
        {
          title: "Vendor Name",
          dataIndex: "vendorName",
          key: "vendorName",
          align: "center",
          filterSearch: true,
          render: (val) => (val ? val : "-"),
        },
        {
          title: "Initiated Date",
          dataIndex: "initiatedDate",
          key: "initiatedDate",
          align: "center",
          render: (val, record) =>
            DateConvert(record?.initiationDate)
              ? DateConvert(record?.initiationDate)
              : "-",
        },
    
        {
          title: "Initiated By",
          dataIndex: "addedBy",
          key: "addedBy",
          align: "center",
          render: (val) => (val ? val : "-"),
        },
        {
          title:'Bank Name',
          dataIndex: "bankName",
          key:"bankName",
          align: "center",
          render: (val) => (val ? val: "-")
        },
        {
          title: 'Product Type',
          dataIndex: 'productType',
          key: 'productType',
          render: (val) => val ? val : '-',
          align:"center"
        }
      ];


    const fetchTransactions = async (pageNumber) => {
        setShowLoader(true);
        let filters = `status=UNASSIGNED&`;
        await getFilteredTransactionAll(filters,pageNumber)
          .then((res) => {
            setTotalCountUA(res.totalCount);
            setUnassignedTransactions(res?.transactionDetailResponseDtoList);
            setShowLoader(false);
          })
          .catch((err) => {
            console.log("err", err);
            setShowLoader(false);
          });
      }

      useEffect(() => {
        fetchTransactions(0)
      },[])

      const onChangeHandler = () => {}

      const items = [
        {
            key: "1",
            label: "",
            children: unassignedTranasactions && <Table
                        columns={colsUassigned}
                        dataSource={unassignedTranasactions}
                        pagination={{
                        pageSize: 10,
                        total: totalCountUA,
                        showSizeChanger: false,
                        position: ["bottomCenter"],
                        }}
                        rowKey={(record) => record?.transactionId}
                        onChange={(page) => {
                            fetchTransactions(page.current - 1);
                        }}
                        className="styledAntd"
                      />
        }
      ]

      return(
        <Tabs
            defaultActiveKey="1"
            items={items}
            onChange={onChangeHandler}
        />
      )

}

export default UnassignedTransactions;